import React from 'react';

function Replay() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M12.5 4.8V0L6.562 6l5.938 6V7.2c3.93 0 7.125 3.228 7.125 7.2s-3.194 7.2-7.125 7.2c-3.93 0-7.125-3.228-7.125-7.2H3c0 5.304 4.251 9.6 9.5 9.6s9.5-4.296 9.5-9.6c0-5.304-4.251-9.6-9.5-9.6z" />
    </svg>
  );
  /* eslint-enable */
}

export default Replay;



// WEBPACK FOOTER //
// ./src/common/icons/Replay.js